/**
 * Monster Onesie — fold measurement (BRIEF §5.1).
 *
 * Publishes --header-stack: the real, measured height of the announcement bar
 * plus the header. The PDP's above-the-fold math is built on it:
 *
 *   .monster-pdp__main  { height:     calc(100vh - var(--header-stack) - 24px) }
 *   .monster-pdp__core  { min-height: calc(100vh - var(--header-stack) - 24px) }
 *
 * §5.1 is explicit that this must be measured rather than hardcoded — the
 * mockup's constant (104px) is only correct at its exact chrome heights, and
 * ours change with the announcement copy wrapping, the logo size, and the
 * merchant's own edits. A hardcoded value doesn't fail loudly; it just quietly
 * pushes the thumbnails above the fold or leaves a band of dead space.
 *
 * Runs on every template, not just the PDP: it is cheap, and the variable is
 * useful anywhere a section wants to reason about the chrome.
 */

const FALLBACK_STACK = 104;

function measure() {
  // #header-group is display:contents and therefore has no box of its own —
  // measuring it directly returns 0. Sum its element children instead.
  const group = document.querySelector('#header-group');
  if (!group) return;

  let total = 0;
  for (const child of group.children) {
    if (!(child instanceof HTMLElement)) continue;

    // A transparent (overlay) header floats over the hero and takes no
    // vertical space in the flow, so it must not count toward the stack.
    if (child.querySelector('header-component[transparent]')) continue;

    total += child.offsetHeight;
  }

  document.documentElement.style.setProperty('--header-stack', `${total || FALLBACK_STACK}px`);
}

const observer = new ResizeObserver(measure);

function init() {
  const group = document.querySelector('#header-group');
  if (!group) return;

  measure();

  for (const child of group.children) {
    if (child instanceof HTMLElement) observer.observe(child);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

// Fonts landing late change the header's height after first paint.
if (document.fonts?.ready) document.fonts.ready.then(measure);
